import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/nota-versao`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
    }
}